import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {DescriptionList, DescriptionListItem} from "peggirkit";
import {DayReport} from "@/data/entities/dayReport";
import {formatMoney} from "@/utils/MoneyUtils";
import ReportCard from "@widgets/reports/dayReport/card/ReportCard";

type Props = {
    dayReport: DayReport,
};

/**
 * VAT of the day per rate.
 */
const DayReportVat = ({dayReport}: Props) => {
    const intl = useIntl();

    return (
        <ReportCard title={<FormattedMessage id={"dayReport.vatTitle"}/>}>
            <DescriptionList compact={true}>
                <DescriptionListItem
                    title={intl.formatMessage({id: "dayReport.vatLow"})}
                    content={formatMoney(dayReport.vatLow)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "dayReport.vatHigh"})}
                    content={formatMoney(dayReport.vatHigh)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "dayReport.vat"})}
                    content={<strong className={"font-semibold"}>{formatMoney(dayReport.vat)}</strong>}
                />
            </DescriptionList>
        </ReportCard>
    );
};

export default DayReportVat;